import * as SiteManager from '../domain/site-manager';
import React, { createContext, useContext } from 'react';
import { useData, dataFromDataset } from './DataProviderCache';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { Data } from '../../types/data-providers';

type ContextState = Data<boolean | null>;

const Context = createContext<ContextState | null>(null);

function useSiteBatteryStatus(): ContextState {
    const contextState = useContext(Context);
    if (contextState === null) {
        throw new Error('useSiteBatteryStatus must be used within a SiteBatteryStatusDataProvider');
    }
    return contextState;
}

const SiteBatteryStatusDataProvider: React.FC<{ siteId: string }> = (props) => {
    const authHelper = useAuthHelper();

    const { dataset } = useData({
        cacheKey: 'site-battery-status-data',
        id: props.siteId,
        dataFn: React.useCallback(
            () => SiteManager.getSiteBatteryStatus(authHelper, { siteId: props.siteId }),
            [authHelper, props.siteId]
        ),
    });
    const statusData = dataFromDataset(dataset);

    return <Context.Provider value={statusData}>{props.children}</Context.Provider>;
};

const TestSiteBatteryStatusDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { SiteBatteryStatusDataProvider, TestSiteBatteryStatusDataProvider, useSiteBatteryStatus };
